/** Canonical origin for parent-facing invite / deep links in production. */
export const TINYWINS_PARENT_ORIGIN = 'https://www.tinywins.ai';

function trimOrigin(origin: string): string {
  return origin.replace(/\/+$/, '');
}

/**
 * Base URL for PARENT invite emails and parent portal deep links.
 * - VITE_PARENT_INVITE_ORIGIN wins when set
 * - On localhost, use the current app origin so local invites resolve against the same AppSync
 * - Otherwise production TinyWins (parents should land on the parent app, not MiraPlus)
 */
export function getParentInviteOrigin(): string {
  const fromEnv = import.meta.env.VITE_PARENT_INVITE_ORIGIN?.trim();
  if (fromEnv) return trimOrigin(fromEnv);

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return trimOrigin(window.location.origin);
    }
  }

  return TINYWINS_PARENT_ORIGIN;
}

export function buildParentReferralUrl(
  token: string,
  extraQuery?: Record<string, string>,
  originOverride?: string,
): string {
  const base = trimOrigin(originOverride || getParentInviteOrigin());
  const url = new URL('/parent-referral', `${base}/`);
  url.searchParams.set('token', token);
  if (extraQuery) {
    for (const [k, v] of Object.entries(extraQuery)) {
      if (v != null && v !== '') url.searchParams.set(k, v);
    }
  }
  return url.toString();
}
